import { render, staticRenderFns } from "./tree-select.vue?vue&type=template&id=1efcc1a3&scoped=true&"
import script from "./tree-select.vue?vue&type=script&lang=js&"
export * from "./tree-select.vue?vue&type=script&lang=js&"
import style0 from "./tree-select.vue?vue&type=style&index=0&lang=less&"
import style1 from "./tree-select.vue?vue&type=style&index=1&id=1efcc1a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efcc1a3",
  null
  
)

export default component.exports